import { TypedAction } from '@ngrx/store/src/models';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ErrorCode, Validator } from '@symphony-solo/shared/error-handling/src';
import { loadCustomerGroupsSuccessAction } from '../+state';
import { CustomerGroupDto } from '../dtos';

export class CustomerGroupsValidator extends Validator<CustomerGroupDto[]> {
  public validate(): TypedAction<any> {
    if (this.data?.length > 0) {
      return loadCustomerGroupsSuccessAction({ customerGroups: this.data });
    }
    throw new AppStateFailureBuilder()
      .setFailureType(FailureType.Validation)
      .addFailure(new AppStateFailureItemWithErrorCode('No Customer Groups', ErrorCode.NoCustomerGroups))
      .build();
  }
}
